import script from "./PanelUpgradeOptIn.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelUpgradeOptIn.vue?vue&type=script&setup=true&lang=js"

import "./PanelUpgradeOptIn.vue?vue&type=style&index=0&id=73cf5a06&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73cf5a06"]])

export default __exports__